import React from 'react'

import { FooterPublic, HeaderPublic } from '../components/shared'

const MainLayout = ({ className, children, pageTitle, hideTitleOnDesktop, fullSidebar = false, fullHeader = false, titleIcon = null, showSearch = false, searchIn = '' }) => {

  let mainClass = 'public-layout'

  if (className) {
    mainClass += ` ${className}`
  }
  if (!fullSidebar) {
    mainClass += ' public-layout--sidebar-shrinked'
  }



  return (
    <div className={mainClass}>
      {/* <div className="public-layout__fix"></div> */}
      <main className="public-layout__main">
        {/* <Sidebar full={fullSidebar} /> */}
        <div className="public-layout__body">

          <HeaderPublic />

          <div className="public-layout__body_content u-custom-scrollbar">
            {children}
          </div>
        </div>
      </main>
      <FooterPublic />
    </div>
  )
}

export default MainLayout